import { render, staticRenderFns } from "./RewardInfoDialog.vue?vue&type=template&id=0a638090"
import script from "./RewardInfoDialog.vue?vue&type=script&lang=js"
export * from "./RewardInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./RewardInfoDialog.vue?vue&type=style&index=0&id=0a638090&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports